import { useCallback, useEffect, useMemo, useState } from "react";
import { appNavigationSections, getActiveNavigationState, readStoredOpenKeys, readStoredSidebarOpen, writeStoredOpenKeys, writeStoredSidebarOpen } from "../../../app/navigation";

const ALL_SECTION_KEYS = appNavigationSections.map((section) => section.key);

export function useSidebarState(pathname) {
    const [collapsed, setCollapsed] = useState(() => !readStoredSidebarOpen(true));
    const [openKeys, setOpenKeys] = useState(() => readStoredOpenKeys(ALL_SECTION_KEYS));
    const { selectedKeys, openSectionKey } = useMemo(() => getActiveNavigationState(pathname), [pathname]);

    useEffect(() => {
        if (!openSectionKey) {
            return;
        }

        setOpenKeys((currentKeys) => {
            if (currentKeys.includes(openSectionKey)) {
                return currentKeys;
            }

            const nextKeys = [...currentKeys, openSectionKey];
            writeStoredOpenKeys(nextKeys);
            return nextKeys;
        });
    }, [openSectionKey]);

    const onOpenChange = useCallback((keys) => {
        setOpenKeys(keys);
        writeStoredOpenKeys(keys);
    }, []);

    const handleCollapse = useCallback(
        (nextCollapsed) => {
            setCollapsed(nextCollapsed);
            writeStoredSidebarOpen(!nextCollapsed);

            if (nextCollapsed) {
                return;
            }

            setOpenKeys((currentKeys) => {
                const baseKeys = currentKeys.length > 0 ? currentKeys : readStoredOpenKeys(ALL_SECTION_KEYS);
                const nextOpenKeys = openSectionKey && !baseKeys.includes(openSectionKey) ? [...baseKeys, openSectionKey] : baseKeys;
                writeStoredOpenKeys(nextOpenKeys);
                return nextOpenKeys;
            });
        },
        [openSectionKey],
    );

    return {
        collapsed,
        openKeys,
        selectedKeys,
        setCollapsed,
        setOpenKeys,
        handleCollapse,
        onOpenChange,
    };
}
